import { render, staticRenderFns } from "./CorporationBlock.vue?vue&type=template&id=55be64c1&scoped=true&"
import script from "./CorporationBlock.vue?vue&type=script&lang=js&"
export * from "./CorporationBlock.vue?vue&type=script&lang=js&"
import style0 from "./CorporationBlock.vue?vue&type=style&index=0&id=55be64c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be64c1",
  null
  
)

export default component.exports